import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { i18nDateToString } from 'modules/core/lib/dates'

import { useDateBookingContext } from 'modules/space_control/components/dateBookingContext'
import { WorkSpaceWithBookingNode } from 'modules/space_control/hooks/useWorkSpacesWithBookings'

interface UseUserMapEventsProps {
  workSpaces: WorkSpaceWithBookingNode[]
}

export const useUserMapEvents = ({ workSpaces }: UseUserMapEventsProps) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const spaceControl = useDateBookingContext()

  const handleSpaceClick = useCallback(
    ({ workSpaceId }: { workSpaceId: number }) => {
      track(trackingEvents.spaceControl.bookings.addBooking, {
        type_space: workSpaces.find((ws) => ws.workSpaceId === workSpaceId)?.workSpaceTypeName,
        capacity: workSpaces.find((ws) => ws.workSpaceId === workSpaceId)?.originalCapacity,
      })
      navigate(
        navigation.spaceControl.overview.booking.fullPath({
          date: i18nDateToString(spaceControl.date, 'backend'),
          workSpaceId: workSpaceId.toString(),
        })
      )
    },
    [workSpaces, navigate, navigation, spaceControl.date]
  )

  const handleMapClick = useCallback((_coordinates: { x: number; y: number }) => {}, [])

  return {
    actions: {
      onPinClick: handleSpaceClick,
      onMapClick: handleMapClick,
    },
  }
}
